import { useMutation, gql } from '@apollo/client';

export const useFormHandlers = () => {
  const ADD_ENQUIRY = gql`
            mutation MyMutation(
               $emailAddress: String!
               $driveNinjaSessionToken: String
               $firstName: String!
               $hubspotSessionToken: String
               $lastName: String!
               $modelId: ID
               $offerId: ID
               $phoneNumber: String!
               $providerId: ID
               $trimLevelId: ID
            ) {
              createDealerEnquiry(
                input: {emailAddress: $emailAddress, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, driveNinjaSessionToken: $driveNinjaSessionToken, hubspotSessionToken: $hubspotSessionToken, modelId: $modelId, offerId: $offerId, providerId: $providerId, trimLevelId: $trimLevelId}
              ) {
                ok
                result {
                  id
                }
                errors {
                  messages
                  field
                }
              }
            }
            `;
  const [addEnquiry] = useMutation(ADD_ENQUIRY);

  const ADD_TEST_DRIVE_ENQUIRY = gql`
  mutation MyMutation(
               $emailAddress: String!
               $driveNinjaSessionToken: String
               $firstName: String!
               $hubspotSessionToken: String
               $lastName: String!
               $modelId: ID
               $offerId: ID
               $phoneNumber: String!
               $providerId: ID
               $trimLevelId: ID
               $branchId: ID
               $testDriveDate:Date!
               $testDriveTime:Time!
            ) {
              createDealerTestDriveEnquiry(
                input: {testDriveDate: $testDriveDate, testDriveTime:$testDriveTime, branchId: $branchId, emailAddress: $emailAddress, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, driveNinjaSessionToken: $driveNinjaSessionToken, hubspotSessionToken: $hubspotSessionToken, modelId: $modelId, offerId: $offerId, providerId: $providerId, trimLevelId: $trimLevelId}
              ) {
                ok
                result {
                  id
                }
                errors {
                  messages
                  field
                }
              }
            }
            `;

  const [addTestDriveEnquiry] = useMutation(ADD_TEST_DRIVE_ENQUIRY);
  const ADD_CALLBACK_ENQUIRY = gql`
  mutation MyMutation(
               $emailAddress: String!
               $driveNinjaSessionToken: String
               $firstName: String!
               $hubspotSessionToken: String
               $lastName: String!
               $modelId: ID
               $offerId: ID
               $phoneNumber: String!
               $providerId: ID
               $trimLevelId: ID
 
               $callBackDate:Date
               $callBackTime:Time
               $callBackAsap:Boolean!
            ) {
              createDealerCallBackEnquiry(
                input: {callBackTime: $callBackTime, callBackDate:$callBackDate,callBackAsap:$callBackAsap, emailAddress: $emailAddress, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, driveNinjaSessionToken: $driveNinjaSessionToken, hubspotSessionToken: $hubspotSessionToken, modelId: $modelId, offerId: $offerId, providerId: $providerId, trimLevelId: $trimLevelId}
              ) {
                ok
                result {
                  id
                }
                errors {
                  messages
                  field
                }
              }
            }
            `;
  const [addCallBackEnquiry] = useMutation(ADD_CALLBACK_ENQUIRY);
  return {
    addEnquiry: ({ formValues }) => new Promise(
      (resolve, reject) => addEnquiry({ variables: formValues }).then(({ data, ...rest }) => {
        if (data?.createDealerEnquiry?.ok) {
          resolve({ data, ...rest });
        } else {
          reject({ data, ...rest });
        }
      }).catch(reject)
    ),
    addTestDriveEnquiry: ({ formValues }) => new Promise(
      (resolve, reject) => addTestDriveEnquiry({ variables: formValues }).then(({ data, ...rest }) => {
        if (data?.createDealerTestDriveEnquiry?.ok) {
          resolve({ data, ...rest });
        } else {
          reject({ data, ...rest });
        }
      }).catch(reject)
    ),
    addCallBackEnquiry:  ({ formValues }) => new Promise(
      (resolve, reject) => addCallBackEnquiry({ variables: formValues }).then(({ data, ...rest }) => {
        if (data?.createDealerCallBackEnquiry?.ok) {
          resolve({ data, ...rest });
        } else {
          reject({ data, ...rest });
        }
      }).catch(reject)
    ),
  };
};